<template>
  <div class="sidebar-left"
       :class="[SIDE_MENU == 1 ? 'opensidebar':'closesidebar' ]">
    <ToolbarIcon/>
    <div class="sidebar-body scroll-pane">
      <div class="side-nav">
        <div
          v-for="(menuItems, index) in menu"
          :key="index"
          class="menu-group"
        >
          <router-link
            v-for="(item, index1) in menuItems"
            :key="index1"
            :to="item.route"
            class="menu-item"
            @click.native="Toggle"
          >
            <font-awesome-icon :icon="item.icon" class="icon menu-icon" /> <span class="ml-3 menu-text">{{ $t(item.title) }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import {mapActions, mapGetters, mapState} from "vuex";
  import ToolbarIcon from "./ToolbarIcon";

export default {
  components: {ToolbarIcon},
  data () {
    return {
      sidebar: 'sidebar',
      menu: [
        [
          {
            title: 'navigation.dashboard',
            icon: 'tachometer-alt',
            route: '/super-admin/dashboard'
          },
          {
            title: 'navigation.accounts',
            icon: 'user',
            route: '/super-admin/accounts'
          },
          {
            title: 'navigation.communication',
            icon: 'phone',
            route: '/super-admin/communications'
          },
          {
            title: 'navigation.email_templates',
            icon: 'envelope',
            route: '/super-admin/emailTemplates'
          },
          {
            title: 'navigation.list_of_actions',
            icon: 'location-arrow',
            route: '/super-admin/listOfActions'
          },
          {
            title: 'navigation.finances_forms',
            icon: 'file-invoice',
            route: '/super-admin/finances-forms'
          }
        ],
        [
          {
            title: 'navigation.pos',
            icon: 'file',
            route: '/super-admin/purchase-orders'
          },
          {
            title: 'navigation.invoices',
            icon: 'file-alt',
            route: '/super-admin/invoices'
          },
          {
            title: 'navigation.payments',
            icon: 'credit-card',
            route: '/super-admin/payments'
          },
          {
            title: 'navigation.preapproved_invoices',
            icon: 'file-invoice',
            route: '/super-admin/preapproved-invoices'
          },
          {
            title: 'navigation.bulk_processing',
            icon: 'database',
            route: '/super-admin/bulk-processing'
          }
        ],
        [
          {
            title: 'navigation.reports',
            icon: 'signal',
            route: '/super-admin/reports'
          }
        ],
        [
          {
            title: 'navigation.activities',
            icon: 'tasks',
            route: '/super-admin/activities'
          }
        ],
        [
          // {
          //   title: 'navigation.backups',
          //   icon: 'save',
          //   route: '/super-admin/backup'
          // },
          {
            title: 'navigation.settings',
            icon: 'cog',
            route: '/super-admin/settings'
          },
          {
            title: 'navigation.islamic_finance_form_template',
            icon: 'file-pdf',
            route: '/super-admin/islamic_finance_forms'
          },
          {
            title: 'navigation.user_guides',
            icon: 'file-pdf',
            route: '/super-admin/user-guides'
          }
        ]
      ]
    }
  },
  computed: {
    ...mapGetters('general', [
      'SIDE_MENU'
    ]),
  },
  methods: {
    Toggle () {
      this.$utils.toggleSidebar()
    },
  }
}
</script>
